import './App.css'
import './LightMode.css'
import QuotesViewController from "./controller/QuotesViewController"
import QuoteViewController from "./controller/QuoteViewController"
import BacklogViewController from "./controller/BacklogViewController"
import ProcessSchedulerViewController from "./controller/ProcessSchedulerViewController"
import FilesUploaderViewController from "./controller/FilesUploaderViewController"
import BillingViewController from "./controller/BillingViewController"
import PurchaseOrderRequestViewController from "./controller/PurchaseOrderRequestViewController"
import PurchaseOrderStateChangingViewController
    from "./controller/PurchaseOrderStateChangingViewController"
import JobViewController from "./controller/JobViewController"
import DailyScheduleViewController from "./controller/DailyScheduleViewController"
import {
    ProductionViewController, ProductionCreateHeader,
    ProductionCreateHeaderRow, ProductionCreateRow,
    ProductionCreateTeamDropDownColumn,
    ProductionCreateLabelDateColumn,
    ProductionCreateMultipleStringsColumn,
    ProductionCreateCustomDropDownColumn,
    ProductionCreateNumberInputColumn,
} from "./controller/ProductionViewController"
import { AddonsAdderViewController } from "./controller/AddonsAdderViewController"
import { ScheduleTemplateBuilderViewController } from "./controller/ScheduleTemplateBuilderViewController"
import PopOversViewController from "./controller/PopOversViewController"
import LoginViewController from "./controller/LoginViewController"
import SettingsViewController from "./controller/SettingsViewController"
import AdminAccountsViewController from "./controller/admin/AdminAccountsViewController"
import EquipAdminViewController from "./controller/admin/EquipAdminViewController"
import GlobalFilesAdminViewController from "./controller/admin/GlobalFilesAdminViewController"
import CapacityViewController from "./controller/CapacityViewController"
import JobCostViewController from "./controller/JobCostViewController"
import DrawingAttributesAdminViewController from "./controller/admin/DrawingAttributesAdminViewController"
import DrawingMetadataViewController from "./controller/DrawingMetadataViewController"
import DrawingDataViewController from "./controller/DrawingDataViewController"
import BacklogReportViewController from "./controller/BacklogReportViewController"
import BacklogSearchViewController from "./controller/BacklogSearchViewController"
import ProjectManagerViewController from "./controller/ProjectManagerViewController"
import EditPaymentInfoViewController from "./controller/EditPaymentInfoViewController"
import CustomerPaymentsViewController from "./controller/CustomerPaymentsViewController"
import CustomerReportViewController from "./controller/CustomerReportViewController"
import AdminPaymentViewController from "./controller/AdminPaymentViewController"
import AdminPaymentJobsViewController from "./controller/AdminPaymentJobsViewController"
import AdminBanksViewController from "./controller/AdminBanksViewController"
import CustomerInformationViewController from "./controller/CustomerInformationViewController"
import MachineChartsViewController from "./controller/MachineChartsViewController"
import MachineDockViewController from "./controller/MachineDockViewController"
import EnvironnmentViewController from "./controller/EnvironnmentViewController"
import ImperfectionAdderViewController from "./controller/ImperfectionAdderViewController"
import PlatesViewerViewController from "./controller/PlatesViewerViewController"
import OpenInvoiceReportViewController from "./controller/OpenInvoiceReportViewController"
import CustomSQLViewController from "./controller/CustomSQLController.js"
import { Quote } from "./model/Quote"
import { Backlog } from './model/Backlog'
import { BacklogSearchModel } from './model/BacklogSearchModel'
import { Account, Roles } from "./model/Account"
import { JustDate } from './model/JustDate'
import { GetParamsObject, ObjectToParams } from './model/request/urlparser'
import { updateQuote } from './model/request/quotes'
import { getReadyForProduction, getReleasedForProduction } from './model/request/schedule'
import { updateBacklogs } from './model/request/backlog'
import history from './history'
import React from "react"
import {
    BrowserRouter as Router,
    //Router,
    Routes,
    Route,
    useParams
} from "react-router-dom";
import {
    Breadcrumb,
    BreadcrumbItem,
    Row,
    Col,
} from 'reactstrap'
import SimpleDropdown from './view/DropDownView'

export default function App() {

    const account = Account.fromCookieAndLocalStorage()
    if (account) {
        const themeNames = account.settings.theme_settings.getThemeNames()
        for (let i = 0; i < themeNames.length; i++) {
            if (themeNames[i].is_custom) {
                const inlinecss = document.createElement('style')
                inlinecss.innerHTML = themeNames[i].value
                document.getElementsByTagName('head')[0].appendChild(inlinecss)
            } else {
                const fileref = document.createElement('link')
                fileref.setAttribute('rel', 'stylesheet')
                fileref.setAttribute('type', 'text/css')
                fileref.setAttribute('href', themeNames[i].value)
                document.getElementsByTagName('head')[0].appendChild(fileref)
            }
        }
    }

  return (
    <Router history={history}>
        <Routes>
          <Route path='/quotes' element={<AllQuotes />}>
          </Route>
          <Route path='/quote/:id' element={<ShowQuote />}>
          </Route>
          <Route path='/quote' element={<ShowNewQuote />} >
          </Route>
          <Route path='/backlog/:id' element={<ShowBacklog />}>
          </Route>
          <Route path='/backlogreport' element={<ShowBacklogReport />}>
          </Route>
          <Route path='/backlogsearch' element={<ShowBacklogSearch />}>
          </Route>
          <Route path='/scheduler/:id' element={<ShowScheduler />}>
          </Route>
          <Route path='/files/:id' element={<ShowFiles />}>
          </Route>
          <Route path='/shipping/:id' element={<ShowShipping />}>
          </Route>
          <Route path='/metadata/:id' element={<ShowMetadata />}>
          </Route>
          <Route path='/drawingdata/:id' element={<ShowDrawingData />}>
          </Route>
          <Route path='/production' element={<ShowProduction />}>
          </Route>
          <Route path='/releasedforproduction' element={<ShowReleasedForProduction />}>
          </Route>
          <Route path='/projectmanagerschedule' element={<ShowProjectManagerSchedule />}>
          </Route>
          <Route path='/purchaseorder' element={<PurchaseOrder />}>
          </Route>
          <Route path='/purchaseorder/:id' element={<PurchaseOrder />}>
          </Route>
          <Route path='/purchaseorderreadytobeorder' element={<ShowPurchaseOrderReadyToBeOrder />}>
          </Route>
          <Route path='/purchaseorderreadytobedelivered'
            element={<ShowPurchaseOrderReadyToBeDelivered />}>
          </Route>
          <Route path='/purchaseorderdelivered'
            element={<ShowPurchaseOrderDelivered />}>
          </Route>
          <Route path='/jobs' element={<AllQuotes />}>
          </Route>
          <Route path='/job/:id' element={<ShowJob />}>
          </Route>
          <Route path='/job' element={<ShowNewQuote />} >
          </Route>
          <Route path='/dailyschedule' element={<ShowDailySchedule />}>
          </Route>
          <Route path='/customerreport' element={<ShowCustomerReportPage />}>
          </Route>
          <Route path='/customerinformation/:customer' element={<ShowCustomerInformationPage />}>
          </Route>
          <Route path='/customerinformation' element={<ShowCustomerInformationPage />}>
          </Route>
          <Route path='/machine' element={<ShowMachineDockPage />}>
          </Route>
          <Route path='/environment' element={<ShowEnvironmentPage />}>
          </Route>
          <Route path='/machineimperfections' element={<ShowImperfectionAdderPage />}>
          </Route>
          <Route path='/machineplates' element={<ShowMachinePlates />}>
          </Route>
          <Route path='/machineimages' element={<ShowMachineImagesPage />}>
          </Route>
          <Route path='/payment/edit' element={<ShowEditPayment />}>
          </Route>
          <Route path='/payment/makepayment' element={<ShowMakePayments />}>
          </Route>
          <Route path='/payment/accounthistory' element={<ShowAccountHistory />}>
          </Route>
          <Route path='/payment/adminpayments' element={<ShowAdminPayment />}>
          </Route>
          <Route path='/payment/adminjobpayments' element={<ShowAdminPaymentJobs />}>
          </Route>
          <Route path='/payment/adminbanks' element={<ShowAdminBanks />}>
          </Route>
          <Route path='/payment/openinvoices' element={<ShowOpenInvoices />}>
          </Route>
          <Route path='/account/login' element={ShowLoginPage(1)}>
          </Route>
          <Route path='/account/create' element={ShowLoginPage(2)}>
          </Route>
          <Route path='/account/forgotpassword' element={ShowLoginPage(3)}>
          </Route>
          <Route path='/account/resetpassword/:id' element={<ShowResetPassword />}>
          </Route>
          <Route path='/account/settings' element={<ShowSettingsPage />}>
          </Route>
          <Route path='/admin/accounts' element={<ShowAccountsAdminPage />}>
          </Route>
          <Route path='/admin/addons' element={<ShowAddonAdminPage />}>
          </Route>
          <Route path='/admin/scheduletemplate' element={<ShowAddonTemplateBuilderAdminPage />}>
          </Route>
          <Route path='/admin/equip' element={<ShowEquipAdminPage />}>
          </Route>
          <Route path='/admin/globalfiles' element={<ShowGlobalFilesAdminPage />}>
          </Route>
          <Route path='/admin/drawingattributes' element={<ShowDrawingAttributesAdminPage />}>
          </Route>
          <Route path='/capacity' element={<ShowCapacityPage />}>
          </Route>
          <Route path='/jobcost' element={<ShowJobCostPage />}>
          </Route>
          <Route path='/customsql' element={<ShowCustomSQLPage />}>
          </Route>
          <Route path='/' element={<ShowNewQuote />} >
          </Route>
        </Routes>
    </Router>
  )
}

function ShowPageCustomerOnly(page) {
    const account = Account.fromCookieAndLocalStorage()
    if (
        !account ||
        !account.hasRole(Roles.Customer) ||
        !account.verified
    ) {
        return AllQuotes()
    }

    return page
}

function ShowMachineistOnly(page) {
    const account = Account.fromCookieAndLocalStorage()
    if (
        !account ||
        !account.hasRole(Roles.Machine) ||
        !account.verified
    ) {
        return AllQuotes()
    }

    return page
}

function ShowCustomSQLOnly(page) {
    const account = Account.fromCookieAndLocalStorage()
    if (
        !account ||
        !account.hasRole(Roles.SelectQuery) ||
        !account.verified
    ) {
        return AllQuotes()
    }

    return page
}

function ShowAsanteOnly(page) {
    const account = Account.fromCookieAndLocalStorage()
    if (
        !account ||
        !account.hasRole(Roles.Asante) ||
        !account.verified
    ) {
        return AllQuotes()
    }

    return page
}

function ShowAdminOnly(page) {
    const account = Account.fromCookieAndLocalStorage()
    if (
        !account ||
        !account.hasRole(Roles.Admin) ||
        !account.verified
    ) {
        return AllQuotes()
    }

    return page
}

function ShowAccountsAdminPage() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account || !(account.hasRole(Roles.Admin) || account.hasRole(Roles.AsanteAdmin) ||
        (account.verified && account.hasRole(Roles.Customer) && !account.hasRole(Roles.Asante)))) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <AdminAccountsViewController />
    </PopOversViewController>
}

function ShowAddonAdminPage() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account || !account.hasRole(Roles.Admin)) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <AddonsAdderViewController />
    </PopOversViewController>
}

function ShowDrawingAttributesAdminPage() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account || !account.hasRole(Roles.Admin)) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <DrawingAttributesAdminViewController />
    </PopOversViewController>
}

function ShowAddonTemplateBuilderAdminPage() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account || !account.hasRole(Roles.Admin)) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <ScheduleTemplateBuilderViewController />
    </PopOversViewController>
}

function ShowSettingsPage() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <SettingsViewController />
    </PopOversViewController>
}

function ShowCustomerReportPage() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    function searchPage(searchTask) {
        const params = ObjectToParams(searchTask)
        history.push('/customerreport' + params)
        // window.location.href = '/customerreport' + params
    }

    const params = GetParamsObject()

    return <PopOversViewController>
        <CustomerReportViewController
            searchPage={searchPage}
            searchParams={params} />
    </PopOversViewController>
}

function ShowResetPassword() {
    const p = useParams()
    const id = p['id']
    return <PopOversViewController noNav={true}>
        <LoginViewController page={4} id={id}/>
    </PopOversViewController>
}

function ShowLoginPage(page) {
    return <PopOversViewController noNav={true}>
        <LoginViewController page={page} />
    </PopOversViewController>
}

function AllQuotes() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return ShowLoginPage(1)
    }
    if (!account.verified) {
        return <ShowNewQuote />
    }

    function inner(index) {
        // history.push('/job/' + index)
        window.location.href = '/job/' + index
    }

    function nextpage(object) {
        const params = ObjectToParams(object)
        // history.push('/quotes' + params)
        window.location.href = '/quotes' + params
    }

    const params = GetParamsObject()

    return <PopOversViewController>
        <QuotesViewController
        params={params}
        viewQuote={inner}
        nextPage={nextpage} />
    </PopOversViewController>
}

function PurchaseOrder() {
    const p = useParams()

    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return ShowLoginPage(1)
    }
    if (!account.verified) {
        return <ShowNewQuote />
    }

    const id = p['id']

    return <PopOversViewController>
        <PurchaseOrderRequestViewController
            id={id}
        />
    </PopOversViewController>
}

// MARK: Stage Changing

function viewQuote(id) {
    // history.push('/quote/' + id)
    window.location.href = '/quote/' + id
}

function viewBacklog(id) {
    // history.push('/backlog/' + id)
    window.location.href = '/backlog/' + id
}

function viewScheduler(id) {
    // history.push('/scheduler/' + id)
    window.location.href = '/scheduler/' + id
}

function viewFiles(id) {
    // history.push('/files/' + id)
    window.location.href = '/files/' + id
}

function viewShipping(id) {
    // history.push('/shipping/' + id)
    window.location.href = '/shipping/' + id
}

function viewMetadata(id) {
    window.location.href = '/metadata/' + id
}

function viewDrawingData(id) {
    window.location.href = '/drawingdata/' + id
}

// MARK: Common Views

function breadCrumbs(index, id) {
    const account = Account.fromCookieAndLocalStorage()
    const values = [
        'Quote', 'Backlog', 'Scheduler', 'Files', 'Shipping', 'Metadata', 'Drawing Data',
    ]
    const filterValues = account && account.hasRole(Roles.Asante) ? values :
        ['Quote', 'Files', 'Metadata']
    const urlMap = [
        '/quote/' + id,
        '/backlog/' + id,
        '/scheduler/' + id,
        '/files/' + id,
        '/shipping/' + id,
        '/metadata/' + id,
        '/drawingdata/' + id,
    ]
    const hrefs = filterValues.map(v => urlMap[values.indexOf(v)])
    return <Row>
        <Col>
            <Breadcrumb tag="nav" listTag="div">
            <BreadcrumbItem tag="a" href="/quotes">Jobs</BreadcrumbItem>
            {!id ? <></> :
            <>
            {account && account.hasRole(Roles.Asante) ? <BreadcrumbItem tag="a" href={"/job/" + id}>Job</BreadcrumbItem> : <></>}
            <BreadcrumbItem active tag="span" style={{
                'display': 'flex',
            }}>
                <SimpleDropdown
                    size="sm"
                    index={filterValues.indexOf(values[index])}
                    values={filterValues}
                    hrefs={hrefs}
                    onChange={(i) => {
                        i = values.indexOf(filterValues[i])
                        if (i === index) {
                            return
                        }
                        switch (i) {
                            case 0:
                                viewQuote(id)
                                break
                            case 1:
                                viewBacklog(id)
                                break
                            case 2:
                                viewScheduler(id)
                                break
                            case 3:
                                viewFiles(id)
                                break
                            case 4:
                                viewShipping(id)
                                break
                            case 5:
                                viewMetadata(id)
                                break
                            case 6:
                                viewDrawingData(id)
                                break
                            default:
                                break
                        }
                    }} />
                </BreadcrumbItem>
                </>
        }
            </Breadcrumb>
        </Col>
    </Row>
}

// MARK: Stages

function ShowQuote() {
    const p = useParams()

    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    const id = p['id']
    return <PopOversViewController>
        <QuoteViewController
            id={id}
            viewBacklog={viewBacklog}
            viewScheduler={viewScheduler}
            viewFiles={viewFiles}
            breadCrumbs={breadCrumbs} />
    </PopOversViewController>
}

function ShowNewQuote() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <QuoteViewController
            quote={new Quote()}
            breadCrumbs={breadCrumbs} />
    </PopOversViewController>
}

function ShowBacklog() {
    const p = useParams()

    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    const id = p['id']
    return <PopOversViewController>
        <BacklogViewController id={id}
            breadCrumbs={breadCrumbs} />
    </PopOversViewController>
}

function ShowBacklogReport() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <BacklogReportViewController />
    </PopOversViewController>
}

function ShowBacklogSearch() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <BacklogSearchViewController
            search={BacklogSearchModel.from({
                'get_params': ['Customer Ship Date'],
                'no_has_params': ['Thermoformed Signs Received'],
            })}/>
    </PopOversViewController>
}

function ShowScheduler() {
    const p = useParams()

    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    const id = p['id']
    return <PopOversViewController>
        <ProcessSchedulerViewController id={id}
            breadCrumbs={breadCrumbs} />
    </PopOversViewController>
}

function ShowMetadata() {
    const p = useParams()
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }
    const id = p['id']
    return <PopOversViewController>
        <DrawingMetadataViewController id={id} breadCrumbs={breadCrumbs} />
    </PopOversViewController>
}

function ShowDrawingData() {
    const p = useParams()
    const id = p['id']
    return ShowAsanteOnly(
        <PopOversViewController>
            <DrawingDataViewController id={id} breadCrumbs={breadCrumbs} />
        </PopOversViewController>
    )
}

function ShowFiles() {
    const p = useParams()

    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    const id = p['id']
    return <PopOversViewController>
        <FilesUploaderViewController
            id={id}
            breadCrumbs={breadCrumbs} />
    </PopOversViewController>
}

function ShowShipping() {
    const p = useParams()

    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    const id = p['id']
    return <PopOversViewController>
        <BillingViewController
            id={id}
            breadCrumbs={breadCrumbs} />
    </PopOversViewController>
}


// Mark: Job

function ShowJob() {
    const p = useParams()

    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    const id = p['id']
    return <PopOversViewController>
        <JobViewController id={id}
            viewQuote={viewQuote}
            viewBacklog={viewBacklog}
            viewScheduler={viewScheduler}
            viewFiles={viewFiles} />
    </PopOversViewController>
}

function ShowDailySchedule() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    function searchPage(searchObject) {
        const params = ObjectToParams(searchObject)
        // history.push('/dailyschedule' + params)
        window.location.href = '/dailyschedule' + params
    }

    const params = GetParamsObject()

    return <PopOversViewController>
        <DailyScheduleViewController
        search={searchPage}
        searchTask={params} />
    </PopOversViewController>
}

function ShowProduction() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <ProductionViewController
            infoMessage={'All jobs that are ready for production and has a customer ' +
                'ship date but are not in production. Includes shipped jobs.'}
            csvfilename='readyforproduction'
            getDataFunc={getReadyForProduction}
            tableHeader={ProductionCreateHeaderRow(<></>, <>
                {ProductionCreateHeader('Team')}
                {ProductionCreateHeader('In Production', '220px')}
            </>)}
            // Team goes in `post`, which ProductionCreateRow renders before
            // the In Production checkbox it appends itself - so the column
            // lands after Thermoformed and before In Production.
            createTableRow={ProductionCreateRow(true, [], [
                ProductionCreateTeamDropDownColumn(),
            ])}
            columnsBeforeTotalPrice={2}
            columnsAfterTotalPrice={2}
            saveJob={(job, context) => {
                context.props.turnOnLoader()
                updateBacklogs([new Backlog(job.backlog_id,
                    job.quote_id, '265feed1-d0ed-4be7-bf5c-49956e25dadc',
                    job.date_picked, job.is_checked, 'Ready For Production', 150)]).then(
                    (result) => {
                        if (result.data.backlogs.length > 0) {
                            job.backlog_id = result.data.backlogs[0].id
                        }
                        context.props.turnOffLoader()
                    },
                    (error) => {
                        context.props.showError(error)
                        context.props.turnOffLoader()
                    }
                )
            }}
        />
    </PopOversViewController>
}

function ShowReleasedForProduction() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <ProductionViewController
            infoMessage={'All jobs that are in production but have not been shipped.'}
            csvfilename='inproduction'
            getDataFunc={getReleasedForProduction}
            tableHeader={ProductionCreateHeaderRow(
                ProductionCreateHeader('Ready For Production'),
                <>
                {ProductionCreateHeader('Tracking Method', '220px')}
                {ProductionCreateHeader('Tracking Numbers', '220px')}
                {ProductionCreateHeader('Shipping Cost', '220px')}
                {ProductionCreateHeader('Shipped', '220px')}
                </>
            )}
            createTableRow={ProductionCreateRow(true, [
                ProductionCreateLabelDateColumn('released_for_production_date'),
            ], [
                ProductionCreateCustomDropDownColumn('shipping_method'),
                ProductionCreateMultipleStringsColumn('tracking_number'),
                ProductionCreateNumberInputColumn('shipping_cost',
                    (job, index, context, newShippingCost) => {
                        job.total_price = job.cost_without_shipping + parseFloat(newShippingCost)
                        context.setState({})
                    },
                ),
            ])}
            columnsBeforeTotalPrice={3}
            saveJob={(job, context) => {
                context.props.turnOnLoader()
                updateQuote({
                    'id': job.quote_id,
                    'is_shipped': job.is_checked,
                    'total_price': job.total_price,
                    'left_to_pay': job.total_price,
                    'shipping_cost': job.shipping_cost,
                    'tracking_number': job.tracking_number,
                    'shipping_method': job.shipping_method,
                    'shipped_date': job.is_checked
                        ? job.date_picked
                        : null,
                }).then(
                    (result) => {
                        context.props.turnOffLoader()
                    },
                    (error) => {
                        context.props.showError(error)
                        context.props.turnOffLoader()
                    }
                )
            }}
        />
    </PopOversViewController>
}

function ShowProjectManagerSchedule() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }
    if (!account.hasRole(Roles.Asante)) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <ProjectManagerViewController />
    </PopOversViewController>
}

function ShowEditPayment() {
    return ShowPageCustomerOnly(
        <PopOversViewController>
            <EditPaymentInfoViewController />
        </PopOversViewController>
    )
}

function ShowMakePayments() {
    return ShowPageCustomerOnly(
        <PopOversViewController>
            <CustomerPaymentsViewController
                canMakePayment={true}
                query={{
                    'min_left_to_pay': 0,
                    'not_left_to_pay': 0,
                }}
            />
        </PopOversViewController>
    )
}

function ShowAccountHistory() {
    return ShowPageCustomerOnly(
        <PopOversViewController>
            <CustomerPaymentsViewController
                canMakePayment={false}
            />
        </PopOversViewController>
    )
}

function ShowAdminPayment() {
    return ShowAdminOnly(
        <PopOversViewController>
            <AdminPaymentViewController />
        </PopOversViewController>
    )
}

function ShowAdminPaymentJobs() {
    return ShowAdminOnly(
        <PopOversViewController>
            <AdminPaymentJobsViewController />
        </PopOversViewController>
    )
}

function ShowAdminBanks() {
    return ShowAdminOnly(
        <PopOversViewController>
            <AdminBanksViewController />
        </PopOversViewController>
    )
}

function ShowOpenInvoices() {
    return <PopOversViewController>
        <OpenInvoiceReportViewController />
    </PopOversViewController>
}

function ShowCustomerInformationPage() {
    const p = useParams()
    const customerName = p['customer']
    return ShowPageCustomerOnly(
        <PopOversViewController>
            <CustomerInformationViewController
                customerName={customerName}
            />
        </PopOversViewController>
    )
}

function ShowMachineImagesPage() {
    return ShowMachineistOnly(
        <PopOversViewController>
            <MachineChartsViewController />
        </PopOversViewController>
    )
}

function ShowMachineDockPage() {
    return ShowMachineistOnly(
        <PopOversViewController>
            <MachineDockViewController />
        </PopOversViewController>
    )
}

function ShowEnvironmentPage() {
    return ShowMachineistOnly(
        <PopOversViewController>
            <EnvironnmentViewController />
        </PopOversViewController>
    )
}

function ShowImperfectionAdderPage() {
    return ShowMachineistOnly(
        <PopOversViewController>
            <ImperfectionAdderViewController />
        </PopOversViewController>
    )
}

function ShowMachinePlates() {
    return ShowMachineistOnly(
        <PopOversViewController>
            <PlatesViewerViewController />
        </PopOversViewController>
    )
}

function ShowGlobalFilesAdminPage() {
    return ShowAdminOnly(
        <PopOversViewController>
            <GlobalFilesAdminViewController />
        </PopOversViewController>
    )
}

function ShowEquipAdminPage() {
    const account = Account.fromCookieAndLocalStorage()
    if (!account || !account.hasRole(Roles.Admin)) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <EquipAdminViewController />
    </PopOversViewController>
}

function ShowCapacityPage() {
    return ShowAsanteOnly(
        <PopOversViewController>
            <CapacityViewController />
        </PopOversViewController>
    )
}

function ShowJobCostPage() {
    return ShowAdminOnly(
        <PopOversViewController>
            <JobCostViewController />
        </PopOversViewController>
    )
}

function ShowCustomSQLPage() {
    return ShowCustomSQLOnly(
        <PopOversViewController>
            <CustomSQLViewController />
        </PopOversViewController>
    )
}

function ShowPurchaseOrderStateChanging(
    filter, title, updateDateVar, updateDateLabel,
    queryDateVarName, queryDateLabel, minDate,
    deliveryDateLabel
) {
    const account = Account.fromCookieAndLocalStorage()
    if (!account) {
        return AllQuotes()
    }
    if (!account.hasRole(Roles.Asante)) {
        return AllQuotes()
    }

    return <PopOversViewController>
        <PurchaseOrderStateChangingViewController
            filter={filter}
            title={title}
            update_date={updateDateVar}
            update_date_label={updateDateLabel}
            query_date_min={minDate}
            query_date_varname={queryDateVarName}
            query_date_label={queryDateLabel}
            delivery_date_label={deliveryDateLabel}
        />
    </PopOversViewController>
}

function ShowPurchaseOrderReadyToBeOrder() {
    return ShowPurchaseOrderStateChanging({
        'order_date': null,
    },
        'Ready To Be Ordered (Step 1/2)',
        'order_date',
        'Order Date',
        'expected_order_date',
        'Expected Order',
        null,
    )
}

function ShowPurchaseOrderReadyToBeDelivered() {
    return ShowPurchaseOrderStateChanging({
        'not_order_date': null,
        'delivery_date': null,
    },
        'Ready To Be Delivered (Step 2/2)',
        'delivery_date',
        'Recieved Date',
        'expected_delivery_date',
        'Expected Delievery',
        null,
    )
}

function ShowPurchaseOrderDelivered() {
    return ShowPurchaseOrderStateChanging({
        'not_order_date': null,
        'not_delivery_date': null,
    },
        'Already Delivered (Done)',
        null,
        null,
        'delivery_date',
        'Delivery',
        (new JustDate())
            .setDate(1)
            .setMonth(
                (new JustDate()).getMonth() - 1
            )
        ,
        'Recieved Date',
    )
}

